import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useStyles from './styles';

const CalendarComponent = ({
  year,
  month,
  day,
  originalPosition,
  selectDay,
}) => {
  const classes = useStyles();

  const calendarTable = [];
  const addNewWeek = () => {
    calendarTable.push(new Array(7).fill(''));
  };
  addNewWeek();

  // It's magic, don't think too much about it
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPreviousMonth = new Date(year, month, 0).getDate();

  const firstDay = new Date(year, month, 1).getDay();
  const lastDay = new Date(year, month, daysInMonth).getDay();
  let currentDay = firstDay;

  for (let i = currentDay - 1; i >= 0; i -= 1) {
    calendarTable[0][i] = {
      value: daysInPreviousMonth + i + 1 - currentDay,
      type: classes.notThisMonth,
    };
  }

  for (let i = 1; i <= daysInMonth; i += 1) {
    calendarTable[calendarTable.length - 1][currentDay] = {
      value: i,
      type: (originalPosition && i === day) ? classes.currentDay : classes.thisMonth,
    };
    if (currentDay === 6 && i !== daysInMonth) {
      currentDay = 0;
      addNewWeek();
    } else {
      currentDay += 1;
    }
  }

  for (let i = currentDay; i < 7; i += 1) {
    calendarTable[calendarTable.length - 1][i] = {
      value: i - lastDay,
      type: classes.notThisMonth,
    };
  }

  const onDayClick = ({ value, type }) => {
    if (type === classes.thisMonth) {
      selectDay(value);
    } else if (type === classes.notThisMonth) {
      if (value < 7) {
        selectDay(value, 1);
      } else {
        selectDay(value, -1);
      }
    }
  };

  return (
    <table>
      <tbody>
        {calendarTable.map((week, i) => (
          <tr key={i}>
            {week.map(dayInfo => (
              <td
                className={classnames(
                  classes.cell,
                  dayInfo.type,
                  { [classes.hoverable]: dayInfo.type !== classes.currentDay },
                )}
                key={dayInfo.value}
                role="button"
                onClick={() => { onDayClick(dayInfo); }}
                onKeyPress={() => { onDayClick(dayInfo); }}
                tabIndex={0}
              >
                {dayInfo.value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};


CalendarComponent.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  originalPosition: PropTypes.bool.isRequired,
  selectDay: PropTypes.func.isRequired,
};

export default CalendarComponent;
